module.exports = __webpack_public_path__ + "static/media/logo4.713a8fcd.png";